import React from 'react';
import { useIntl } from 'react-intl';
import styles from './SearchButton.module.scss';
interface SearchButtonProps {
    onClick: (e: React.MouseEvent<HTMLElement>) => void;
}
export const SearchButton = ({ onClick }: SearchButtonProps) => {
    const { formatMessage } = useIntl();
    return (
        <div className={styles.root}>
            <button className={styles.searchButton} onClick={onClick} type="button">
                <svg
                    aria-label={formatMessage({
                        id: 'search button',
                        defaultMessage: 'search button',
                    })}
                    xmlns="http://www.w3.org/2000/svg"
                    width={36}
                    height={36}
                    fill="none"
                >
                    <circle cx={18} cy={18} r={18} />
                    <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M20.926 19.426a6 6 0 1 0-1.454 1.468L24.5 26l1.5-1.5-5.074-5.074ZM16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
                        clipRule="evenodd"
                    />
                </svg>
            </button>
        </div>
    );
};
